module.exports = __webpack_public_path__ + "Pages-icon.0fd5f549d439c281557b.woff";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/assets/fonts/pages-icon/Pages-icon.woff?-u69vo5
// module id = ../../../../../src/assets/fonts/pages-icon/Pages-icon.woff?-u69vo5
// module chunks = main